import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/lms-profiles.action'
import lmsProfilesCreate from 'api/lms-profiles/Create'
import { ILmsProfileModel } from 'models/lmsProfile.model'
import I18n from 'i18n'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import { errorMessage } from 'helpers/validators.helper'

async function createProfile(data: ILmsProfileModel) {
  return await lmsProfilesCreate(data)
}

function* lmsProfilesCreateEffectSaga(action: any) {
  try {
    const { data } = yield call(createProfile, action.payload)
    yield put(fromActions.Actions.lmsProfilesCreateSuccess(data))
    yield put(fromActions.Actions.lmsProfileListReload())
    SuccessToast(I18n.t('administration.toastMessages.profileCreateSuccess'))
  } catch (error) {
    ErrorToast(I18n.t(`administration.toastMessages.${errorMessage(error, 'createError')}`))
    console.log('error: ', error)
  }
}

export function* lmsProfilesCreateWatcherSaga() {
  yield takeLatest(fromActions.LMS_PROFILES_CREATE, lmsProfilesCreateEffectSaga)
}
